class FreeGiftPopup extends HTMLElement {
  constructor() {
    super();

    this.timeToShow = parseInt(this.getAttribute('data-delay')) || 0;

    this.overlay = this.querySelector('.drawer__overlay');
    this.content = this.querySelector('.popup__inner');

    this.querySelector('.popup__close')?.addEventListener('click', this.dismiss.bind(this));
    this.overlay?.addEventListener('click', this.dismiss.bind(this));
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) this.dismiss();
    };
  }

  connectedCallback() {
    document.addEventListener('keydown', this.onKeydown);

    if (window.Shopify && Shopify.designMode) return;

    setTimeout(() => this.open(), this.timeToShow);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open() {
    this.activeElement = document.activeElement;
    this.setAttribute('open', 'true');
    document.body.classList.add('overflow-hidden');
    document.documentElement.setAttribute('scroll-lock', '');
  }

  dismiss() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.removeAttribute('scroll-lock');
    if (this.activeElement) this.activeElement.focus();
  }
}

if (!customElements.get('free-gift-popup')) customElements.define('free-gift-popup', FreeGiftPopup);
